import React from 'react';
import cx from 'classnames';
import styles from './MenuHeader.css';
export const MenuHeader = props => {
    return (React.createElement("header", { className: cx(props.className, styles.header) },
        React.createElement("h1", null, props.text),
        props.children && React.createElement("div", null, props.children)));
};
